import { UpdateCollection } from '@/components/blocks/pickup-point/pickup-point-select-modal/pickup-point-select-modal';

export function groupByPickupPoint(
  passengers: Content.Components['PassengerDto'][],
): UpdateCollection['selected'] {
  const map = new Map<string, string[]>();

  for (const passenger of passengers) {
    if (!passenger.selectedPickupPoint) continue;

    const pickupPointId =
      passenger.selectedPickupPoint.pickupPointId.toString();
    const hashes = map.get(pickupPointId) ?? [];

    hashes.push(passenger.uniquePaxHash);
    map.set(pickupPointId, hashes);
  }

  return Array.from(map, ([pickupPointId, uniquePaxHashes]) => ({
    pickupPointId,
    uniquePaxHashes,
  }));
}
